//import { Enum_Userspermissionsuser_Ong } from '../../graphql/generated/graphql';

export const NgoListWithInfos = [
  {
    name: 'Planete_urgence',
    displayName: 'Planète Urgence',
    descriptions: [
      "Les forêts disparaissent. La biodiversité s’effondre. Les communautés locales sont en danger. C'est inacceptable !",
      'Depuis 25 ans, Planète Urgence agit pour protéger les forêts, préserver la biodiversité et renforcer les populations qui en dépendent'
    ],
    actions: [
      '🌿 Nous reboisons',
      '🌍 Nous sensibilisons',
      '🤝 Nous agissons aux côtés des communautés locales'
    ],
    catchPhrases: [
      'Le monde a encore besoin de notre engagement. Ensemble, défendons notre planète !'
    ],
    equivalences: ['1€ = un arbre planté'],
    embedId: 'GP638IkY46Q'
  },
  {
    name: 'Un_enfant_par_la_main',
    displayName: 'Un Enfant Par la Main',
    descriptions: [
      "Des millions d’enfants sont privés d’éducation, d’avenir et de dignité. C'est inacceptable !",
      'Depuis 35 ans, Un Enfant par la Main agit pour offrir à chaque enfant et à sa famille les moyens de grandir et de s’épanouir.'
    ],
    actions: [
      '📚 Nous scolarisons',
      '💧 Nous protégeons',
      '❤️ Nous soutenons les familles'
    ],
    catchPhrases: [
      'Le monde a encore besoin de notre engagement. Ensemble, changeons la vie des enfants !'
    ],
    equivalences: [
      "1€ = une journée d'accompagnement d'un enfant et sa famille"
    ],
    embedId: '-ws2y5tb1vY'
  },
  {
    // to do
    name: 'Societe_protectrice_des_animaux',
    displayName: 'Société Protectrice des Animaux',
    descriptions: [
      'Agir pour les animaux, c’est défendre la compassion, la justice, et le respect de la vie.',
      "Les abandons augmentent. Les maltraitances se multiplient. Des milliers d’animaux souffrent chaque année dans le silence. C'est inacceptable !"
    ],
    actions: [
      '🐶 Nous recueillons et soignons',
      '📣 Nous sensibilisons le public',
      '🏠 Nous favorisons l’adoption responsable'
    ],
    catchPhrases: [
      'Le combat continue. Ensemble, offrons-leur un avenir meilleur !'
    ],
    equivalences: [
      '1€ = une journée de nourriture pour un chien OU 3 jours de nourriture pour un chat '
    ],
    embedId: 'HE_mc6PoKOs'
  }
];
